


































import KeyStats from "@/components/KeyStats.vue";
import KeyName from "@/components/KeyName.vue";
import { Key, KeyCat } from "@/types/debug-mode";
import { NotificationType, Issue } from "@/types/notification";
import { Features } from "@/types/settings";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    KeyStats,
    KeyName,
  },
})
export default class PopularKey extends Vue {
  created() {
    // Set issue initially, then watch for changes below to re-evaluate
    this.setIssue();
  }

  @Getter("settings/activeCacheFeatures") features!: Features;

  @Prop({ required: true })
  cacheKey!: Key;

  @Prop({ required: true })
  keyCat!: KeyCat;

  @Prop({ required: true })
  timeSlice!: number; // nanoseconds

  @Watch("cacheKey")
  onUpdate() {
    this.setIssue();
  }

  showKeyStats = false;

  initalIssue: Issue = {
    type: NotificationType.DEFAULT,
    message: "",
    icon: "",
  };

  issue = this.initalIssue;

  // format popularity
  // e.g. 1200.321 => 1,200.32/s
  get popularity() {
    return `${this.cacheKey.popularity.toFixed(2).toLocaleString()}/s`;
  }

  get icon() {
    return this.showKeyStats ? "caret-up" : "caret-down";
  }

  toggleShowKeyStats() {
    this.showKeyStats = !this.showKeyStats;

    const ga = this.showKeyStats ? "Show key stats" : "Hide key stats";
    this.$ga.toggle(ga);
  }

  setIssue() {
    // if we have data for at least 10s
    if (this.timeSlice / 10 ** 9 > 10) {
      // help for Most Missed Keys
      if (this.keyCat === "missed") {
        const helpText = "missed key. Cache too small or possible implementation bug (i.e. item never stored)";
        if (this.cacheKey.popularity >= 1) {
          this.issue = {
            type: NotificationType.ERROR,
            message: `Very frequently ${helpText}`,
            icon: "exclamation-circle",
          };
          return;
        } else if (this.cacheKey.popularity > 0.1) {
          this.issue = {
            type: NotificationType.WARNING,
            message: `Frequently ${helpText}`,
            icon: "exclamation-circle",
          };
          return;
        }
      }
    }

    // reset
    if (this.issue.type !== "") {
      this.issue = Object.assign({}, this.initalIssue);
    }
  }
}
